"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addUDDataToGlobalState = void 0;
const addUDDataToGlobalState = (udData) => {
    global.UD = udData;
};
exports.addUDDataToGlobalState = addUDDataToGlobalState;
//# sourceMappingURL=ud-data.js.map